module.exports = __webpack_public_path__ + "img/dashboard-selected.df40dde1.svg";